import { render, staticRenderFns } from "./OTPTest.vue?vue&type=template&id=06279102&"
import script from "./OTPTest.vue?vue&type=script&lang=js&"
export * from "./OTPTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports